import ChargebeeAddon from '../../calculator/ChargebeeAddon'
import getPlanPricing from '../../calculator/getPricing'
import { Pricing } from '../../types'
import Feature from '../Feature'
import PlanVariant from '../PlanVariant'
import { PlanTypeEnum } from '../types'
import {
  DATO_PLAN_DESCRIPTION_FIELD,
  DATO_PLAN_ID_FIELD,
  DATO_PLAN_TITLE_FIELD,
  DEFAULT_ICON,
  PRO_PLAN_TYPE,
  STARTER_PLAN_TYPE,
  getVariantFromID,
} from '../utils'

export function initCoreVariants(
  rawBundles: Pricing,
  country: string
): { coreVariants: PlanVariant[] } {
  const coreVariants: PlanVariant[] = []

  rawBundles.allCorePlans.forEach((corePlan) => {
    const features = corePlan.regions[0].features.map(
      (feature) => new Feature(feature.title, feature.tooltip, feature.highlightInModules ?? false)
    )
    const chargebeeAddons = corePlan.regions[0].chargebeePlans.map((addon) => {
      return new ChargebeeAddon(
        addon.planId,
        addon.currencyCode,
        addon.period,
        addon.periodUnit,
        addon.pricingModel,
        addon.chargeType,
        addon.selectedCountries,
        addon.price,
        addon.tiers
      )
    })

    const pricing = getPlanPricing(chargebeeAddons, country)

    // If there is no compatible pricing, ignore this plan
    if (!pricing) return

    const planType: PlanTypeEnum = corePlan[DATO_PLAN_ID_FIELD].toLowerCase().includes(
      PRO_PLAN_TYPE
    )
      ? PRO_PLAN_TYPE
      : STARTER_PLAN_TYPE

    const variantOptions = {
      id: corePlan[DATO_PLAN_ID_FIELD],
      title: corePlan[DATO_PLAN_TITLE_FIELD],
      type: getVariantFromID(corePlan[DATO_PLAN_ID_FIELD]),
      description: corePlan[DATO_PLAN_DESCRIPTION_FIELD],
      icon: DEFAULT_ICON,
      features,
      pricing,
      planType,
    }
    const variant = new PlanVariant(variantOptions)

    coreVariants.push(variant)
  })

  return { coreVariants }
}
